import { useState } from 'react';

var useMailchimpFeedback = function useMailchimpFeedback(defaultTimeout) {
  if (defaultTimeout === void 0) {
    defaultTimeout = 6000;
  }

  var initialFeedbackMessage = {
    type: undefined,
    message: undefined
  };

  var _useState = useState(initialFeedbackMessage),
      feedbackMessage = _useState[0],
      setFeedbackMessage = _useState[1];

  var _useState2 = useState(true),
      hasForm = _useState2[0],
      setHasForm = _useState2[1];

  var _useState3 = useState(false),
      hasFeedback = _useState3[0],
      setHasFeedback = _useState3[1];

  var handleFeedbackMessage = function handleFeedbackMessage(_ref) {
    var type = _ref.type,
        message = _ref.message,
        _ref$feedbackCallback = _ref.feedbackCallback,
        feedbackCallback = _ref$feedbackCallback === void 0 ? function () {} : _ref$feedbackCallback,
        _ref$timeout = _ref.timeout,
        timeout = _ref$timeout === void 0 ? defaultTimeout : _ref$timeout;
    setHasForm(false);
    setHasFeedback(true);
    setFeedbackMessage({
      type: type,
      message: message
    });
    var timer = setTimeout(function () {
      setHasForm(true);
      setHasFeedback(false);
      var callbackTimer = setTimeout(function () {
        feedbackCallback();
      }, defaultTimeout / 2);
      return function () {
        return clearTimeout(callbackTimer);
      };
    }, timeout);
    return function () {
      return clearTimeout(timer);
    };
  };

  return {
    handleFeedbackMessage: handleFeedbackMessage,
    hasForm: hasForm,
    hasFeedback: hasFeedback,
    feedbackMessage: feedbackMessage,
    defaultTimeout: defaultTimeout
  };
};

export default useMailchimpFeedback;